const initialState = {
    responseCoveragesList: [],
    responseCoverage: [],
    responseRequirementsList: [],
    errorRequirement: false,
    responseRequirement: [],
    errorRequirementStatus: false
};

const reducer = (state = initialState, action) => {
    const newState = { ...state };

    switch (action.type) {
        case "COVERAGES_RESPONSE_LIST":
            // console.log("COVERAGES_RESPONSE_LIST")
            if (action.value.detail !== undefined)
                newState.responseCoveragesList = []
            else
                newState.responseCoveragesList = action.value;
            break;
        case "COVERAGE_RESPONSE":
            // console.log("COVERAGE_RESPONSE")
            newState.responseCoverage = action.value;
            break;
        case "REQUIREMENTS_RESPONSE":
            newState.responseRequirementsList = action.response
            if (action.response.detail !== undefined) newState.errorRequirement = true;
            else newState.errorRequirement = false

            break;
        case "REQUIREMENT_RESPONSE":
            if(action.value.status !== undefined && action.value.status === 409){
                newState.responseRequirement = action.value;
                newState.errorRequirementStatus = true
            }else{
                newState.responseRequirement = action.value;
                newState.errorRequirementStatus = false
            }
            
            break;
        case "RESPONSE_REQUIREMENT_TO_COVERAGE":
            if (action.value.detail !== undefined){
                newState.responseRequirementToCoverage = []
                newState.errorResponseRequirementToCoverage = true
            }else{
                newState.responseRequirementToCoverage = action.value;
                newState.errorResponseRequirementToCoverage = false
            }
            break;
        default:
            return newState;
    }

    return newState;
};

export default reducer;